/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeButton,
  BaSeGrid,
  BaSeGridItem,
  BaSeParagraph,
  BaSeTheme,
  BaSeToggler,
} from '@base/react';
import React from 'react';
import { Popover } from '../../candidates-styled';
import DateRange from './date-range';
import MyRecords from './my-records';
import ProcessingDate from './procesing-date';

function FilterTable({
  setFilter,
  fixedFilters,
  handleFixedFilter,
  settingsTable,
  popoverRef,
  setOpen,
  handleChangeCustomFilter,
  filtersCustom,
  handleClearFilter,
  convertDate,
}) {
  const handleFilter = React.useCallback(() => {
    setTimeout(() => setOpen(false), 10);

    const filterFormated = {
      ...filtersCustom,
      periodStart: convertDate(filtersCustom.periodStart),
      periodEnd: convertDate(filtersCustom.periodEnd),
      initialProcessingDate: convertDate(filtersCustom.initialProcessingDate),
      finalProcessingDate: convertDate(filtersCustom.finalProcessingDate),
    };

    setFilter((prevFilter) => {
      const newFilter = {
        ...prevFilter,
        ...filterFormated,
         origin: filterFormated.myRecords ? 'MANAGER':filterFormated.registeredOnPortal? 'LANDING_PAGE':'',
      };
      delete newFilter.registeredOnPortal;
      return newFilter;
    });
  }, [filtersCustom, convertDate, setFilter, setOpen]);

  return (
    <Popover ref={popoverRef}>
      <DateRange
        title={settingsTable.custonFilterInscriptionDate}
        filters={filtersCustom}
        handleChange={handleChangeCustomFilter}
        fixedFilters={fixedFilters}
        handleFixedFilter={handleFixedFilter}
        insideFilter={true}
      />

      <ProcessingDate
        title={settingsTable.custonFilterDate}
        filters={filtersCustom}
        handleChange={handleChangeCustomFilter}
        fixedFilters={fixedFilters}
        handleFixedFilter={handleFixedFilter}
        insideFilter={true}
      />

      <hr style={{ margin: '15px 0', color: '#f3f3f3' }} />

      <BaSeGrid gap={6}>
        <BaSeGridItem size={5}>
          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
            Cadastros do portal
          </BaSeParagraph>
        </BaSeGridItem>

        <BaSeGridItem size={5}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <BaSeToggler
              value={filtersCustom.registeredOnPortal}
              color={!filtersCustom.registeredOnPortal ? '#939393' : ''}
              onChange={() => {
                handleChangeCustomFilter(
                  'registeredOnPortal',
                  !filtersCustom.registeredOnPortal,
                );
                if (filtersCustom.myRecords) {
                  handleChangeCustomFilter('myRecords', false);
                }

                handleChangeCustomFilter(
                  'origin',
                  !filtersCustom.registeredOnPortal ? 'LANDING_PAGE' : '',
                );
              }}
            />
          </div>
        </BaSeGridItem>
        <BaSeGridItem size={2}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <BaSeButton
              value={fixedFilters.registeredOnPortal ? 'Desafixar' : 'Fixar'}
              type="tertiary"
              color={fixedFilters.registeredOnPortal ? '#ffa4a4' : '#005EB8'}
              onClick={() => {
                handleFixedFilter('registeredOnPortal');
              }}
            />
          </div>
        </BaSeGridItem>
      </BaSeGrid>

      <MyRecords
        filters={filtersCustom}
        handleChange={handleChangeCustomFilter}
        fixedFilters={fixedFilters}
        handleFixedFilter={handleFixedFilter}
        insideFilter={true}
        setFilter={setFilter}
      />
      <hr style={{ margin: '15px 0', color: '#f3f3f3' }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <BaSeButton value="Filtrar" onClick={handleFilter} />
      </div>
    </Popover>
  );
}

export default FilterTable;
